export default __webpack_public_path__ + "static/media/anamaria.1867f9fa.jpg";